/***
 * 公用常量配置
 */
export default {
  install(Vue) {
    //会员等级
    Vue.prototype.memberUser_all = [
      {
        value: "0",
        label: '店铺会员'
      },
      {
        value: "1",
        label: '普通会员'
      },
      {
        value: "2",
        label: '高级会员'
      },
      {
        value: "3",
        label: 'VIP会员'
      },
      {
        value: "4",
        label: '至尊VIP会员'
      }
    ];
    //性别
    Vue.prototype.sex_all = [
      {
        value: '0',
        label: '未知'
      },
      {
        value: '1',
        label: '男'
      },
      {
        value: '2',
        label: '女'
      },
    ];
    //全局引用，并且或者
    Vue.prototype.sureOr_all = [
      {
          id: 0,
          label: '并且'
      },
      {
          id: 1,
          label: '或者'
       }
     ];
    //职业
    Vue.prototype.worker_all = [
      {
        value: '1',
        label: '学生'
      },
      {
        value: '2',
        label: '白领'
      },
      {
        value: '3',
        label: '公务员'
      }
      ,
      {
        value: '4',
        label: 'IT'
      }
      ,
      {
        value: '5',
        label: '金融族'
      },
      {
        value: '6',
        label: '居家族'
      },
      {
        value: '7',
        label: '医护人员'
      },
      {
        value: '8',
        label: '其他'
      }
    ];
  }
}